import { Component } from "react";
import EdicionMasivaEntidad from "../../../../Components/EdicionMasivaEntidad";

// Backend: erp_backend/Controllers/edicionMasivaProveedores.controllers.js
// Fuera a propósito: tipo de proveedor (tiene su flujo de "Cambiar tipo"), cuentas contables,
// retenciones, proyectos, insumo de gasto, proveedor extranjero, archivos y credenciales.

const dosDigitos = (n) => String(n ?? "").padStart(2, "0");

// Mismas etiquetas que los selects de EditarProveedor.
const TIPOS_OPERACION = {
  1: "03 - Prestacion de servicios",
  2: "06 - Arrendamiento de inmuebles",
  3: "85 - Otros",
  4: "NA - No asignados",
  5: "02 - Enajenación de bienes",
  6: "07 - Importación de bienes o servicios",
  7: "08 - Importación por transferencia virtual",
  8: "87 - Operaciones globales",
};
const TIPOS_TERCERO = {
  1: "04 - Proveedor Nacional",
  2: "05 - Proveedor Extranjero",
  3: "15 - Proveedor Global",
};
const METODOS_PAGO = { 1: "PUE", 2: "PPD" };
const METODO_PAGO_PPD = 2;
const FORMA_PAGO_POR_DEFINIR = 99;

const GRUPOS = [
  {
    key: "generales",
    label: "Generales",
    color: "595959",
    fijo: true,
    columnas: ["ID", "Codigo", "Clave", "RFC", "Razon Social", "Nombre", "Apellido Paterno", "Apellido Materno", "Nombre Comercial"],
  },
  {
    key: "contacto",
    label: "Contacto",
    color: "2F54EB",
    columnas: [
      "Celular",
      "Telefono",
      "Correo",
      "Correos Adicionales",
      "Pagina Web",
      "Nombre Contacto",
      "Telefono Contacto",
      "Correo Contacto",
      "Jefe Contacto",
      "Puesto Jefe Contacto",
      "Observaciones",
    ],
  },
  {
    key: "fiscales",
    label: "Fiscales",
    color: "1890FF",
    columnas: [
      "CURP",
      "Regimen Fiscal",
      "Uso de CFDI",
      "Metodo de Pago",
      "Forma de Pago",
      "Tipo Operacion DIOT",
      "Tipo Tercero DIOT",
    ],
  },
  {
    key: "creditoBancos",
    label: "Crédito y Bancos",
    color: "52C41A",
    columnas: [
      "Dias Credito",
      "Limite Credito",
      "Descuento Predeterminado",
      "Moneda",
      "Banco",
      "Cuenta Banco",
      "Cuenta CLABE",
      "Pago Electronico",
    ],
  },
  {
    key: "direccion",
    label: "Dirección",
    color: "13C2C2",
    columnas: ["Codigo Postal", "Colonia", "Calle", "Numero", "Numero Interior"],
  },
];

const COLUMNAS = [
  { col: "Codigo", campo: "codigo", tipo: "soloLectura" },
  { col: "Clave", campo: "clave", tipo: "texto" },
  { col: "RFC", campo: "rfc", tipo: "rfc" },
  { col: "Razon Social", campo: "razonSocial", tipo: "mayusculas", patron: true },
  { col: "Nombre", campo: "nombre", tipo: "mayusculas", patron: true },
  { col: "Apellido Paterno", campo: "apellidoPaterno", tipo: "mayusculas", patron: true },
  { col: "Apellido Materno", campo: "apellidoMaterno", tipo: "mayusculas", patron: true },
  { col: "Nombre Comercial", campo: "nombreComercial", tipo: "mayusculas", patron: true },
  { col: "Celular", campo: "celular", tipo: "telefono" },
  { col: "Telefono", campo: "telefono", tipo: "telefono" },
  { col: "Correo", campo: "correo", tipo: "correo" },
  { col: "Correos Adicionales", campo: "correosAdicionales", tipo: "correos" },
  { col: "Pagina Web", campo: "paginaWeb", tipo: "texto" },
  { col: "Nombre Contacto", campo: "nombreContacto", tipo: "texto" },
  { col: "Telefono Contacto", campo: "telefonoContacto", tipo: "telefono" },
  { col: "Correo Contacto", campo: "correoContacto", tipo: "correo" },
  { col: "Jefe Contacto", campo: "jefeContacto", tipo: "texto" },
  { col: "Puesto Jefe Contacto", campo: "puestoJefeContacto", tipo: "texto" },
  { col: "Observaciones", campo: "observaciones", tipo: "texto" },
  { col: "CURP", campo: "curp", tipo: "mayusculas" },
  { col: "Regimen Fiscal", campo: "regimenFiscalId", tipo: "referencia", catalogo: "regimenes" },
  { col: "Uso de CFDI", campo: "usoDeCfdiId", tipo: "referencia", catalogo: "usos" },
  { col: "Metodo de Pago", campo: "metodoPago", tipo: "enum", labels: METODOS_PAGO },
  { col: "Forma de Pago", campo: "formaDePagoId", tipo: "referencia", catalogo: "formasDePago" },
  { col: "Tipo Operacion DIOT", campo: "tipoOperacion", tipo: "enum", labels: TIPOS_OPERACION, requerido: true },
  { col: "Tipo Tercero DIOT", campo: "tipoTercero", tipo: "enum", labels: TIPOS_TERCERO, requerido: true },
  { col: "Dias Credito", campo: "diasCredito", tipo: "numero" },
  { col: "Limite Credito", campo: "limiteCredito", tipo: "numero" },
  { col: "Descuento Predeterminado", campo: "descuentoPredeterminado", tipo: "numero" },
  { col: "Moneda", campo: "monedaId", tipo: "referencia", catalogo: "monedas", requerido: true },
  { col: "Banco", campo: "bancoSatId", tipo: "referencia", catalogo: "bancosSat" },
  { col: "Cuenta Banco", campo: "cuentaBanco", tipo: "digitos", max: 20 },
  { col: "Cuenta CLABE", campo: "cuentaClabe", tipo: "digitos", longitud: 18 },
  { col: "Pago Electronico", campo: "pagoElectronico", tipo: "bool" },
  { col: "Codigo Postal", campo: "cp", tipo: "direccion" },
  { col: "Colonia", campo: "colonia", tipo: "direccion" },
  { col: "Calle", campo: "calle", tipo: "direccion" },
  { col: "Numero", campo: "numeroCalle", tipo: "direccion" },
  { col: "Numero Interior", campo: "numeroInterior", tipo: "direccion" },
];

const catalogos = (datos) => ({
  regimenes: {
    lista: datos.regimenesFiscales || [],
    etiqueta: (r) => `${r.c_RegimenFiscal} - ${r.descripcion}`,
    clave: (r) => String(r.c_RegimenFiscal),
  },
  usos: {
    lista: datos.usosDeCFDI || [],
    etiqueta: (u) => `${u.c_UsoCFDI} - ${u.descripcion}`,
    clave: (u) => u.c_UsoCFDI,
  },
  formasDePago: {
    lista: datos.formasDePago || [],
    etiqueta: (f) => `${dosDigitos(f.c_FormaPago)} - ${f.descripcion}`,
    clave: (f) => dosDigitos(f.c_FormaPago),
  },
  monedas: { lista: datos.monedas || [], etiqueta: (m) => m.abreviacion || "" },
  bancosSat: { lista: datos.bancosSat || [], etiqueta: (b) => b.nombreCorto || "", clave: (b) => b.clave || "" },
});

const direccionDe = (p) => ({
  cp: p._cp || "",
  colonia: p._colonia || "",
  calle: p.calle || "",
  numeroCalle: p.numeroCalle ?? "",
  numeroInterior: p.numeroInterior || "",
});

// Con método de pago PPD la única forma de pago válida es 99, igual que el select de
// EditarProveedor. Se revisa la combinación que va a quedar guardada.
const validarFila = (proveedor, cambios, ctx) => {
  if (!("metodoPago" in cambios) && !("formaDePagoId" in cambios)) return [];
  const metodoPago = "metodoPago" in cambios ? cambios.metodoPago : proveedor.metodoPago;
  const formaId = "formaDePagoId" in cambios ? cambios.formaDePagoId : proveedor.formaDePagoId;
  const forma = ctx.catalogos.formasDePago.lista.find((f) => String(f._id) === String(formaId));
  if (metodoPago === METODO_PAGO_PPD && forma && Number(forma.c_FormaPago) !== FORMA_PAGO_POR_DEFINIR) {
    return ["Forma de Pago: con método de pago PPD sólo se permite 99 - Por definir"];
  }
  return [];
};

const CONFIG = {
  titulo: "Edición Masiva de Proveedores",
  singular: "proveedor",
  plural: "proveedores",
  idCampo: "proveedorId",
  endpoints: {
    datos: "proveedores/datosParaEdicionMasivaProveedores",
    preview: "proveedores/proveedoresPreviewEdicionMasiva",
    exportar: "proveedores/proveedoresParaExportarEdicionMasiva",
    editar: "proveedores/editarProveedoresMasivo",
  },
  claveExportar: "proveedores",
  nombreArchivo: "edicion_masiva_proveedores.xlsx",
  hoja: "Proveedores",
  grupos: GRUPOS,
  columnas: COLUMNAS,
  catalogos,
  direccionDe,
  validarFila,
  filtros: [
    {
      key: "tipoProveedorIds",
      placeholder: "Filtrar por Tipo de Proveedor",
      opciones: (d) => (d.tiposProveedor || []).map((t) => ({ label: t.nombre, value: t._id })),
    },
  ],
  columnasPreview: [
    { title: "Código", dataIndex: "codigo", key: "codigo", width: 90, sorter: true },
    { title: "Clave", dataIndex: "clave", key: "clave", width: 120, sorter: true },
    { title: "RFC", dataIndex: "rfc", key: "rfc", width: 150, sorter: true },
    { title: "Nombre", dataIndex: "nombre", key: "nombre" },
    { title: "Tipo de Proveedor", dataIndex: "tipo", key: "tipo", width: 200 },
  ],
  hojasCatalogo: [
    { nombre: "Catalogo Regimen Fiscal", catalogo: "regimenes", columnas: ["Regimen Fiscal"] },
    { nombre: "Catalogo Uso de CFDI", catalogo: "usos", columnas: ["Uso de CFDI"] },
    { nombre: "Catalogo Forma de Pago", catalogo: "formasDePago", columnas: ["Forma de Pago"] },
    { nombre: "Catalogo Moneda", catalogo: "monedas", columnas: ["Moneda"] },
    { nombre: "Catalogo Bancos", catalogo: "bancosSat", columnas: ["Banco"] },
  ],
  instrucciones: [
    "Instrucciones de uso",
    "",
    "1. La columna ID es OBLIGATORIA y NO debe modificarse ni eliminarse. La columna Codigo es solo para identificar al proveedor: no se modifica.",
    "2. Las primeras dos filas son encabezados: la fila 1 agrupa las columnas por sección y la fila 2 trae el nombre de cada columna. No borre ninguna de las dos.",
    "3. Puede BORRAR las columnas que NO desee editar. Solo se modificarán las columnas presentes en el archivo y solo los valores que cambie.",
    "4. RFC: si cambia de 12 a 13 caracteres (o al revés), el proveedor pasa a persona física o moral. Persona moral requiere Razon Social; persona física requiere Nombre. No se aceptan RFC repetidos.",
    "5. Columnas SI/NO: use SI o NO. Metodo de Pago: use PUE o PPD; con PPD la Forma de Pago debe ser 99.",
    `6. Tipo Operacion DIOT: ${Object.values(TIPOS_OPERACION).join(", ")}. Basta con la clave (03, 85...).`,
    `7. Tipo Tercero DIOT: ${Object.values(TIPOS_TERCERO).join(", ")}. Basta con la clave (04, 05, 15).`,
    "8. Regimen Fiscal, Uso de CFDI, Forma de Pago, Moneda y Banco: escriba el valor tal como aparece en su hoja \"Catalogo ...\". En Regimen, Uso y Forma de Pago basta con la clave (601, G03, 01). Moneda no puede quedar vacía.",
    "9. Cuenta CLABE: 18 dígitos. Cuenta Banco: hasta 20 dígitos.",
    "10. Correos Adicionales: separe los correos con punto y coma (;).",
    "11. Dirección: escriba el Codigo Postal y el nombre de la Colonia; si el CP tiene una sola colonia puede dejar la Colonia vacía.",
  ],
  ejemplos: {
    ID: ["No modificar (se genera al descargar)"],
    Codigo: ["Solo lectura"],
    Clave: ["PROV-001"],
    RFC: ["ABC010203XY1", "PEGJ800101AB2"],
    "Razon Social": ["DISTRIBUIDORA ABC SA DE CV"],
    Nombre: ["JUAN"],
    "Apellido Paterno": ["PÉREZ"],
    "Apellido Materno": ["GÓMEZ"],
    "Nombre Comercial": ["ABC REFACCIONES"],
    Celular: ["5512345678"],
    Telefono: ["5587654321"],
    Correo: ["ventas@proveedor.com"],
    "Correos Adicionales": ["cobranza@proveedor.com; facturas@proveedor.com"],
    "Pagina Web": ["https://proveedor.com"],
    "Nombre Contacto": ["Pedro Ruiz"],
    "Telefono Contacto": ["5511112222"],
    "Correo Contacto": ["pedro@proveedor.com"],
    "Jefe Contacto": ["Laura Méndez"],
    "Puesto Jefe Contacto": ["Gerente de Ventas"],
    Observaciones: ["Entrega los martes"],
    CURP: ["PEGJ800101HDFRMN09"],
    "Regimen Fiscal": ["601 - General de Ley Personas Morales", "612"],
    "Uso de CFDI": ["G01 - Adquisición de mercancías", "G03"],
    "Metodo de Pago": ["PUE", "PPD"],
    "Forma de Pago": ["03 - Transferencia electrónica de fondos", "99"],
    "Tipo Operacion DIOT": ["85 - Otros", "03"],
    "Tipo Tercero DIOT": ["04 - Proveedor Nacional", "05"],
    "Dias Credito": ["30"],
    "Limite Credito": ["50000"],
    "Descuento Predeterminado": ["5"],
    Moneda: ["MXN", "USD"],
    Banco: ["BANAMEX", "BBVA MEXICO"],
    "Cuenta Banco": ["1234567890"],
    "Cuenta CLABE": ["002180012345678901"],
    "Pago Electronico": ["SI", "NO"],
    "Codigo Postal": ["06000"],
    Colonia: ["Centro"],
    Calle: ["Av. Juárez"],
    Numero: ["100"],
    "Numero Interior": ["3B"],
  },
};

class EdicionMasivaProveedores extends Component {
  render() {
    return <EdicionMasivaEntidad config={CONFIG} history={this.props.history} />;
  }
}

export default EdicionMasivaProveedores;
